import React from "react";
import MDBox from "components/MDBox";
import Slide51 from "assets/images/TheSolutionImages/Slide5/Slide51.png";

function Slide5() {
  return (
    <MDBox textAlign="left" px={{ xs: 2, md: 4 }} width="100%">
      <MDBox
        width="100%"
        maxWidth={{ xs: "100%", md: "95%", lg: "1320px" }}
        height={{ xs: "auto", md: "540px" }}
        margin="0 auto"
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
        gap={4}
        px={{ xs: 2, md: 3 }}
        py={3}
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0)",
          borderRadius: "12px",
        }}
      >
        {/* Left Column - Text */}
        <MDBox
          flex="1"
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          height="100%"
          maxHeight="100%"
          overflowY="auto"
          pr={1}
          color="white"
        >
          <h1
            style={{
              fontSize: "clamp(24px, 5vw, 32px)",
              fontWeight: "bold",
              marginBottom: "16px",
            }}
          >
            SharpWatch® Eco-System
          </h1>

          <MDBox fontSize={{ xs: "18px", md: "24px" }} lineHeight={1.6}>
            <div style={{ marginBottom: "16px", color: "white" }}>
              Data Interface connects to DCS/MCS and streams data
            </div>
            <div style={{ marginBottom: "16px", color: "white" }}>
              Data is stored in the Historian
            </div>
            <div style={{ marginBottom: "16px", color: "white" }}>
              Operators interact via the HMI Client
            </div>
          </MDBox>
        </MDBox>

        {/* Right Column - Image */}
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={{ xs: "100%", md: "50%" }}
          maxWidth={{ xs: "100%", md: "800px" }}
          mt={{ xs: 3, md: 0 }}
        >
          <img
            src={Slide51}
            alt="SharpWatch Eco-System"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "8px",
              objectFit: "contain",
            }}
          />
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

export default Slide5;
